import ReactDOM from 'react-dom/client';
import App from './App';
import { ShopPage } from './shop/ShopPage';
import { siteConfig } from './siteConfig';
import { usePath } from './router';
import './i18n';
import './styles/theme.css';
import './styles/base.css';

// StrictMode is intentionally off: it double-invokes mount effects in dev,
// which causes the pexeso intro to run twice (cleanup wipes the first
// timers before their setCards fires) and leaves the shuffle in a
// broken state. Production builds never run StrictMode side-effects
// anyway, so we lose nothing by keeping it off.

function Root() {
  const path = usePath();
  const normalized = path.replace(/\/+$/, '') || '/';
  if (siteConfig.pages.shop.enabled && normalized === siteConfig.pages.shop.path) {
    return <ShopPage />;
  }
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
